// extracted by mini-css-extract-plugin
export default {"getstartedscreen":"getstartedscreen_b8b7906efd0e775f9d81","header":"header_c93c0e3485f3bc26a6b8","main":"main_f2b01bfa7b4d711fbf0b","sidebar":"sidebar_d14073363facaa1c64e3"};